import styled, { keyframes } from "styled-components"

export const Container = styled.div`
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    box-shadow: 0px 2px 5px black;
    padding: 10px; 
    background-color: black; 
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
    transform: ${({ active }) => (active? 'translateY(0)': 'translateY(-100%)')};
    transition: 300ms;
    background-color: ${({ top }) => (top? 'black': '#0c0c0c')};

    @media (max-width: 700px) { 
        padding-top: 25px;
    }
    
`;

export const Group = styled.div`
`;

export const Logo = styled.img`
    height: 50px;
    margin-left: 20px;
    cursor: pointer;
    border-radius: 15px;

    &:hover{
        background: rgba(255,255,255,0.05);
    }
    
    @media (max-width: 700px) { 
        margin-left: 15 px;
    }
    
    @media (max-width: 400px) { 
        margin-left: 0px;
    }
`;

export const ContainerList = styled.div`
    display: inline-flex;

`;


const fadeIn = keyframes`
  from {
    transform: translateY(-150%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
  
`;


export const Item = styled.a`
    opacity: 0;
    display: inline-flex;
    margin-right: 30px;
    cursor: pointer;
    color: #e0e0e0;
    text-decoration: none;
    animation: ${fadeIn} 500ms forwards;

    &:hover{
        color: #BB86FC;
    }

    :nth-child(2) {
        animation-delay: .2s;
    }
    :nth-child(3) {
        animation-delay: .4s;
    
    }
`;

export const ItemMounted = styled.a`
    display: inline-flex;
    margin-right: 30px;
    cursor: pointer;
    color: #e0e0e0;
    text-decoration: none;

    &:hover{
        color: #BB86FC;
    }

`;

export const Number = styled.p`
    color: #BB86FC;
    margin-right:4px;
`;


export const Section = styled.p`
    color: #e0e0e0;
`;


// css for burger menu

export const BurgerMenu = styled.div`
    font-size: 30px;
    margin-right: 20px;
    color: #BB86FC;
    cursor: pointer;
    
    @media (max-width: 700px) { 
        margin-right: 15 px;
    }
    
    @media (max-width: 400px) { 
        margin-right: 0px;
    }
`;

export const NavMenuBehind = styled.div`
    width: 100%;
    height: 100vh;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    transition: 600ms;
    transform: ${({ active }) => (active? 'opacity(1)': 'opacity(0)')};
    display: ${({ active }) => (active? 'true': 'none')};

`;


export const NavMenu = styled.div`
    background-color: #1c1c1c;
    display: flex;
    width: 60%;
    height: 100vh;
    justify-content: start;
    position: fixed;
    text-align: center;
    flex-direction: column;
    top: 0;
    right: 0;
    opacity: 1;
    z-index: 10;
    transform: ${({ active }) => (active? 'translateX(0%) ': 'translateX(100%)')};
    transition: 450ms;
    
`;

export const MenuExitContainer =styled.div`
    position: fixed;
    top: 30px;
    right: 40px;
    font-size: 30px;
    cursor: pointer;
    color: #BB86FC;

    
    
    @media (max-width: 700px) { 
        top: 30 px;
        right: 35px;
    }
    
    @media (max-width: 400px) { 
        top: 30px;
        right: 25px;
    }


`;

export const MenuItemListContainer = styled.div`
    width: 100%;
    height: 30%;
    margin-top: 100px;
    
`;
export const MenuItemContainer = styled.div`
    display:block;
    width: min-content;
    margin: 0 auto;
    margin-top: 40px;
    
`;

export const MenuItemNumber = styled.p`
    color: #BB86FC;
    margin-right:4px;
    font-size: 17px;
`;

export const MenuItemName = styled.a`
    text-decoration: none;
    font-size: 20px;
    color: #e0e0e0;
    cursor: pointer;
    
    &:hover{
        color: #BB86FC;
    }
    
`;



